import React from "react";
import { Helmet } from "react-helmet-async";

export default function SanteEquilibre() {
  const titlePage = 'Santé Équilibre | Weblax';
  const description = 'Site pour praticien bien-être et médecine alternative.';

  return (
    <>
      <Helmet>
        <title>{titlePage}</title>
        <meta name="description" content={description} />
      </Helmet>

      <main className="weblax-container py-20">
        <h1 className="weblax-heading-display mb-6">Santé Équilibre</h1>
        <p className="text-lg text-muted-foreground mb-10">Site pour praticien bien-être et médecine alternative.</p>


        <section className="mb-10">
          <h2 className="text-2xl font-bold mb-3">Contexte</h2>
          <p className="text-muted-foreground">Présence professionnelle.</p>
        </section>
        
        <section className="mb-10">
          <h2 className="text-2xl font-bold mb-3">Solution</h2>
          <p className="text-muted-foreground">Site rassurant + SEO local.</p>
        </section>
        
        <section className="mb-10">
          <h2 className="text-2xl font-bold mb-3">Résultats</h2>
          <p className="text-muted-foreground">Plus de RDV.</p>
        </section>
        
      </main>
    </>
  );
}
